import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  IconButton
} from "@mui/material";
import { Close as CloseIcon, CameraAlt as CameraIcon } from "@mui/icons-material";

interface PhotoConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onSkip: () => void;
  onTakePhoto: () => void;
}

const PhotoConfirmationModal: React.FC<PhotoConfirmationModalProps> = ({
  open,
  onClose,
  onSkip,
  onTakePhoto,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        padding: '8px 24px',
        fontSize:'16px'
      }}>
        Would you like to take a photo of odometer reading?
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogActions sx={{justifyContent:'center', display:'flex', padding: '8px 24px'}}>
        <Button 
          color="error"
          sx={{border:'1px solid red'}} 
          onClick={() => {
            onClose();
            onSkip();
          }}
        >
          Skip
        </Button>
        <Button 
          variant="contained" 
          sx={{backgroundColor:'green'}}
          startIcon={<CameraIcon />}
          onClick={() => {
            onClose();
            onTakePhoto();
          }}
        >
          Take Photo
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PhotoConfirmationModal;